import React from "react";
import { useNavigate } from "react-router-dom";

const Advertisement = ({bike}) => {
    const {brand, running, Engine, sellerLoaction, sellingPrice, _id} = bike;

    const navigate = useNavigate();

    const handleBikeDetails = (data) =>{
        navigate(`/bike/${_id}`, {state: data});
        console.log(data)
    }


  return (
      <div onClick={()=>handleBikeDetails(bike)} className="card card-side bg-base-100 gap-5 my-4 py-4  shadow-xl flex lg:w-2/3 w-full mx-auto  items-center">
        <figure>
          <img className="w-64 p-5 lg:mx-10" src={bike.img} alt="Movie" />
        </figure>
        <div className="">
          <h2 className="text-2xl font-semibold">{bike.model}</h2>
          <p className="text-xl my-2">{bike.running}km, {bike.Engine}</p>
          <p className="text-xl my-2">{bike.sellerLoaction}</p>
          <h1 className="text-2xl font-semibold text-[#149777]">Price: {bike.sellingPrice} Tk</h1>
        </div>
    </div>
  );
};

export default Advertisement;
